module.exports = __webpack_public_path__ + "img/logo_transmai.84af02b8.png";